import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'ClientTax';
const ENDPOINT = `/client-taxes/`;

@Injectable({
    providedIn: 'root'
})
export class ClientTaxService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
